import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import axios from '../../utils/axiosInstance';
import { Notification } from '../types';

const listKey = (unread?: boolean) => ['notifications', unread ? 'unread' : 'all'] as const;

export const useNotifications = (unreadOnly = false) =>
  useQuery<Notification[]>({
    queryKey: listKey(unreadOnly),
    queryFn: async () => {
      const q = unreadOnly ? '?unread=1' : '';
      const res = await axios.get(`api/notifications/${q}`);
      return res.data;
    },
    refetchInterval: 60_000,
  });

export const useUnreadCount = () =>
  useQuery<{ count: number }>({
    queryKey: ['notifications', 'unread-count'],
    queryFn: async () => (await axios.get('api/notifications/unread-count/')).data,
    refetchInterval: 60_000,
  });

export const useMarkRead = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: number): Promise<Notification> => {
      const res = await axios.post(`api/notifications/${id}/read/`);
      return res.data;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['notifications'] });
    },
  });
};

export const useMarkAllRead = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      const res = await axios.post('api/notifications/mark-all-read/');
      return res.data;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['notifications'] });
    },
  });
};
